export default "__VITE_ASSET__D2fR3qu3__"